import {
  VALIDATE_COUPON_REQUEST,
  VALIDATE_COUPON_SUCCESS,
  VALIDATE_COUPON_FAILURE,
  CLEAR_COUPON,
  SET_CART_ITEMS,
  UPDATE_CART_TOTALS,
  PROCESS_STRIPE_PAYMENT_REQUEST,
  PROCESS_STRIPE_PAYMENT_SUCCESS,
  PROCESS_STRIPE_PAYMENT_FAILURE,
  UPDATE_CART_DETAILS,
} from '../../constants/ActionTypes';

// Remove these as they're no longer needed
// export const VALIDATE_COUPON = 'VALIDATE_COUPON';
// export const VALIDATE_COUPON_ERROR = 'VALIDATE_COUPON_ERROR';


// Coupon Action Creators
export const validateCoupon = (code) => ({
  type: VALIDATE_COUPON_REQUEST,
  payload: code
});

export const validateCouponSuccess = (couponData) => ({
  type: VALIDATE_COUPON_SUCCESS,
  payload: couponData
});

export const validateCouponFailure = (error) => ({
  type: VALIDATE_COUPON_FAILURE,
  payload: error
});

export const clearCoupon = () => ({
  type: CLEAR_COUPON
});

export const setCartItems = (items) => ({
  type: SET_CART_ITEMS,
  payload: items
});

export const updateCartTotals = () => ({
  type: UPDATE_CART_TOTALS
});

// Stripe Payment Action Creators
export const updateCartDetails = (cartDetails) => ({
  type: UPDATE_CART_DETAILS,
  payload: cartDetails
});

export const processStripePaymentRequest = (paymentData) => ({
  type: PROCESS_STRIPE_PAYMENT_REQUEST,
  payload: paymentData
});

export const processStripePaymentSuccess = (response) => ({
  type: PROCESS_STRIPE_PAYMENT_SUCCESS,
  payload: response
});

export const processStripePaymentFailure = (error) => ({
  type: PROCESS_STRIPE_PAYMENT_FAILURE,
  payload: error
});

